/**
 * Shared video URL classification utilities.
 * Used by the Movies player.
 */

// Returns a YouTube video ID from any common YouTube URL shape, or null.
export function extractYouTubeId(url) {
  if (!url) return null;
  // Handles: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID,
  //          youtube.com/shorts/ID, youtube.com/v/ID, plus ?si= tracking params
  const m = url.match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  return m ? m[1] : null;
}

// Returns a Vimeo video ID from any common Vimeo URL shape, or null.
export function extractVimeoId(url) {
  if (!url) return null;
  const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return m ? m[1] : null;
}

/**
 * Classify a URL so the player knows how to render it.
 * @param {string} url
 * @returns {{ type: 'youtube'|'vimeo'|'direct', embedUrl: string }}
 */
export function classifyVideoUrl(url) {
  const ytId = extractYouTubeId(url);
  if (ytId) {
    return {
      type: 'youtube',
      embedUrl: `https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0&modestbranding=1`,
    };
  }
  const vmId = extractVimeoId(url);
  if (vmId) {
    return {
      type: 'vimeo',
      embedUrl: `https://player.vimeo.com/video/${vmId}?autoplay=1&title=0&byline=0&portrait=0`,
    };
  }
  return { type: 'direct', embedUrl: url };
}
